import { apiSlice } from "../app/api/apiSlice";

export const inscriptionApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getAllSeasons: builder.query({
      query: () => ({
        url: `/inscriptions/get-all-seasons`,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError
        }, 
      }),
      invalidatesTags: ['Inscription', 'User']
    }), 
    sendJustificatif: builder.mutation({
      query: (data) => ({
        url: '/emails/justificatif',
        method: 'POST',
        body: data,
      }),
    }),
    getAllTarifs: builder.query({
      query: (id_season) => ({
        url: `/inscriptions/get-all-tarifs/${id_season}`,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError
        }, 
      }),
      invalidatesTags: ['Inscription', 'User']
    }), 
    getAllPaymentMethods: builder.query({
      query: () => ({
        url: `/inscriptions/get-all-paymentMethods`,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError
        }, 
      }),
      invalidatesTags: ['Inscription', 'User']
    }), 
    insertInscription: builder.mutation({
      query: data => ({
          url: `/inscriptions/insert-inscription`,
          method: 'POST',
          body: {
              ...data,
          }
      }),
      invalidatesTags: ['Inscription', 'User']
    }),
    updateInscription: builder.mutation({
      query: data => ({
          url: `/inscriptions/update-inscription`,
          method: 'POST',
          body: {
              ...data,
          }
      }),
      invalidatesTags: ['Inscription', 'User']
    }),
  })
})


export const { 
  useGetAllSeasonsQuery, useGetAllTarifsQuery, useGetAllPaymentMethodsQuery, useInsertInscriptionMutation,
  useUpdateInscriptionMutation, useSendJustificatifMutation
} = inscriptionApiSlice